import { render, staticRenderFns } from "./CaseLogsHistory.vue?vue&type=template&id=16fb38e8&"
import script from "./CaseLogsHistory.vue?vue&type=script&lang=js&"
export * from "./CaseLogsHistory.vue?vue&type=script&lang=js&"
import style0 from "./CaseLogsHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports